export const BOARD_SIZE = 15;
export const CENTRE_ROW = 7;
export const CENTRE_COL = 7;
export const RACK_SIZE = 7;
/** Size of the daily-puzzle bag (a subset of the official 100-tile Scrabble distribution). */
export const BAG_SIZE = 15;
export const BINGO_BONUS = 50;
//# sourceMappingURL=types.js.map